<template>
    <div style="background-color: #fafafa;">
		<van-nav-bar title="配件余额表" left-text="返回"  left-arrow @click-left="onClickLeft" fixed></van-nav-bar>
		<div class="psiConfirmCont">
			<van-search class="search-box" shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch()" @input="onSearch()"
						@cancel="onSearch()" @clear="onSearch()">
				<div slot="action" style="color: #1890ff;" @click="onSearch()">搜索</div>
			</van-search>
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="没有更多了">
					<div v-for="(item, index) in list" class="card" :key="item.skuId">
						<table class="layout" style="width: 100%;" >
							<tr style="width: 100%;" >
								<td colspan="2">
									<div class="header">
										<span class="title">品牌：{{item.brandIdname}}</span>
									</div>
								</td>
							</tr>
							<tr style="width: 100%;">
								<td colspan="2" class="content" style="width: 90%;">
									<span>系列：</span><span>{{item.parentName}}</span>
								</td>
							</tr>
							<tr style="width: 100%;" >
								<td colspan="2" style="width: 40%;" class="content"><span>型号：</span><span>{{item.categoryName}}</span></td>
							</tr>
							<tr style="width: 100%;" >
								<td colspan="2" style="width: 40%;" class="content"><span>规格：</span><span>{{item.skuName}}</span></td>
							</tr>
							<tr style="width: 100%;">
								<td colspan="2" style="width: 40%;" class="content"><span>单位：</span><span>{{item.skuUnit}}</span></td>
							</tr>
							<tr style="width: 100%;">
								<td colspan="2" style="width: 40%;" class="content"><span>数量：</span><span style="font-weight: bold;color:#1890ff;">{{item.quantity}}</span></td>
							</tr>
						</table>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
    </div>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup, PullRefresh, NavBar, Stepper, Toast, Checkbox, CheckboxGroup, Dialog} from 'vant';
	import dealerOrderService from "../../service/dealerOrderService";
    import {formatDictionary} from "../../utils/dictionary";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				value: "",
				data: {},
            }
        },
      
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Stepper.name]: Stepper,
			[NavBar.name]: NavBar,
			[Checkbox.name]: Checkbox,
			[CheckboxGroup.name]: CheckboxGroup
        },
		created: function () {
			this.data.radCategory = this.$route.query.radCategory || "";
			this.data.radId = this.$route.query.radId || "";
			this.data.skuId = this.$route.query.skuId || ""
		},
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await dealerOrderService.getPartsInventoryList(this.pageIndex, this.value, this.data);
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
			onSearch() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			onClickLeft(){
				this.$router.push("invIndex");
			}
        }
    };

</script>
<style>
	.card p {
		margin:10px 0;
	}
	.card p>span:first-child {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}
	.van-checkbox__label{
		color: white;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		margin-top:100px;
		overflow: hidden;
		padding-bottom: 150px;
	}
</style>